import React, { useEffect, useState } from 'react';
import { featuresApi } from '../../services/webApi';

const Ozellikler = () => {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    // Initialize AOS
    const initAOS = () => {
      if (window.AOS) {
        window.AOS.init();
      }
    };

    // Initialize Lucide Icons - Manuel yaklaşım
    const initLucide = () => {
      const createIcons = () => {
        if (window.lucide && window.lucide.createIcons) {
          console.log('Creating Lucide icons manually...');
          try {
            window.lucide.createIcons();
            console.log('Icons created successfully');
          } catch (error) {
            console.error('Error creating icons:', error);
          }
        } else {
          console.log('Lucide not ready, retrying...');
          setTimeout(createIcons, 200);
        }
      };
      
      createIcons();
    };

    // Fetch features from API
    const fetchFeatures = async () => {
      try {
        const response = await featuresApi.getAll();
        if (isMounted && response.data.success) {
          setFeatures(response.data.data);
        } else if (isMounted) {
          setError('Veriler yüklenemedi');
        }
      } catch (err) {
        console.error('Features fetch error:', err);
        if (isMounted) {
          setError('Veriler yüklenirken hata oluştu');
          // Fallback to static data
          setFeatures([
            {
              icon: 'users',
              title: 'Abone Yönetimi',
              description: 'Tüm abonelerinizi tek bir panelden yönetin. Abone bilgileri, paket detayları ve faturalama işlemlerini kolayca takip edin.',
              details: ['Abonenin tüm hizmetlerini tek panelden yönetme', 'Paket yönetimi', 'Fatura takibi', 'Ödeme geçmişi']
            },
            {
              icon: 'file-text',
              title: 'BTK Loglama',
              description: 'BTK gereksinimlerine uygun olarak tüm loglama işlemlerini otomatik olarak gerçekleştirin.',
              details: ['Abone Loglama', 'Abone Rehber Loglama', 'Abone Hareket Loglama', 'Nat (IPDR) Loglama', 'Oturum Loglama', 'IPDR Loglama', 'AIH Abone Loglama', 'AIH Abone Rehber Loglama']
            },
            {
              icon: 'server',
              title: 'Mikrotik Yönetimi',
              description: 'Mikrotik cihazlarınızı uzaktan yönetin ve konfigürasyonlarını merkezi olarak kontrol edin.',
              details: ['CGNat Loglama Sistemi', 'Netmap Nat Loglama Sistemi', 'Load Balancing', 'Uzaktan erişim', 'Konfigürasyon yönetimi', 'Performans izleme']
            },
            {
              icon: 'building',
              title: 'Türk Telekom Entegrasyonu',
              description: 'Türk Telekom sistemleri ile tam entegrasyon sağlayarak tüm işlemlerinizi otomatikleştirin.',
              details: ['Yeni Tesis', 'Churn', 'Tarife Değişikliği', 'Nakil', 'Dönüşüm', 'Başvuru Durum Sorgulama', 'DTS Fatura Analizi', 'Arıza Yönetimi', 'Alt Yapı Sorgulama']
            },
            {
              icon: 'credit-card',
              title: 'Ödeme Yönetimi',
              description: 'Abonelerinizin ödemelerini takip edin ve otomatik faturalama sistemi ile süreçleri hızlandırın.',
              details: ['Otomatik faturalama', 'Ödeme takibi', 'Bildirim sistemi', 'Raporlama', 'Kurum Tahsilatları']
            },
            {
              icon: 'bar-chart',
              title: 'Raporlama',
              description: 'Detaylı raporlar ile işletmenizin performansını analiz edin ve stratejik kararlar alın.',
              details: ['Gelir raporları', 'Abone analizi', 'Performans metrikleri', 'Özelleştirilebilir raporlar']
            },
            {
              icon: 'phone-call',
              title: 'Çağrı Merkezi',
              description: 'Kendi santralinizi kullanarak operatör bağımsız çağrı merkezi sistemi kurun. Akıllı IVR ile müşteri deneyimini optimize edin.',
              details: ['Operatör bağımsız santral', 'CRM entegrasyonu', 'Akıllı IVR sistemi', 'Otomatik arama talepleri', 'Müşteri hizmetleri sıralaması', 'Abone durumuna göre yönlendirme']
            }
          ]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    // Hemen başlat
    initAOS();
    fetchFeatures();
    
    // İkonları biraz sonra oluştur
    setTimeout(() => {
      initLucide();
    }, 1000);

    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-white">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    console.log('Error:', error);
  }

  return (
    <>
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-[72px] backdrop-blur-3xl">
        <div className="overlay"></div>
        <div className="stars" aria-hidden="true"></div>
        <div className="starts2" aria-hidden="true"></div>
        <div className="stars3" aria-hidden="true"></div>

        <div className="px-6 pt-20 overflow-hidden" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="800">
          <div className="container">
            <div className="py-14 text-center relative">
              <div className="flex justify-center">
                <div className="max-w-2xl">
                  <h2 className="md:text-6xl/tight text-5xl text-default-100 font-semibold mb-6">
                    <span className="bg-gradient-to-l from-rose-500 to-primary text-transparent bg-clip-text">Özellikler</span>
                    <br />Güçlü Sistem Özellikleri
                  </h2>
                  <p className="text-sm font-medium text-default-400 mt-5">
                    ISP Radius'un sunduğu kapsamlı özellikler ile işletmenizi büyütün.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-14">
        <div className="container">
          <div className="flex items-end justify-between mb-10">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-3xl font-medium capitalize text-white mb-4">Sistem Özellikleri</h2>
              <p className="text-sm text-default-200 font-medium">ISP Radius'un güçlü özelliklerini keşfedin</p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="group p-6 rounded-xl bg-default-950/40 transition-all duration-500 hover:-translate-y-2 hover:bg-primary/40 border border-white/10"
                data-aos="fade-up" 
                data-aos-easing="ease" 
                data-aos-duration="1000"
                data-aos-delay={index * 100}
              >
                <div className="text-center">
                  <div className="inline-flex items-center justify-center h-16 w-16 bg-primary/10 text-primary rounded-xl mb-6 mx-auto">
                    <i data-lucide={feature.icon} className="h-8 w-8"></i>
                  </div>
                  <h3 className="text-xl font-medium text-white mb-4">{feature.title}</h3>
                  <p className="text-sm text-default-300 mb-6">{feature.description}</p>
                  
                  {feature.details && feature.details.length > 0 && (
                    <div className="space-y-2">
                      {feature.details.map((detail, detailIndex) => (
                        <div key={detailIndex} className="flex items-center gap-2 text-xs text-default-400">
                          <div 
                            className="bg-primary rounded-full"
                            style={{
                              width: '6px',
                              height: '6px',
                              flexShrink: 0
                            }}
                          ></div>
                          <span>{detail}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why ISP Radius Section */}
      <section className="py-14">
        <div className="container">
          <div className="flex items-end justify-between mb-10">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-3xl font-medium capitalize text-white mb-4">Neden ISP Radius?</h2>
              <p className="text-sm text-default-200 font-medium">Sektörde tercih edilme nedenlerimiz</p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center p-6 rounded-xl bg-default-950/40 border border-white/10" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000">
              <div className="inline-flex items-center justify-center h-16 w-16 bg-primary/10 text-primary rounded-xl mb-6 mx-auto">
                <i data-lucide="shield-check" className="h-8 w-8"></i>
              </div>
              <h3 className="text-xl font-medium text-white mb-4">BTK Uyumluluğu</h3>
              <p className="text-sm text-default-300">Tüm BTK gereksinimlerine uygun loglama sistemi</p>
            </div>

            <div className="text-center p-6 rounded-xl bg-default-950/40 border border-white/10" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="100">
              <div className="inline-flex items-center justify-center h-16 w-16 bg-primary/10 text-primary rounded-xl mb-6 mx-auto">
                <i data-lucide="zap" className="h-8 w-8"></i>
              </div>
              <h3 className="text-xl font-medium text-white mb-4">Hızlı Kurulum</h3>
              <p className="text-sm text-default-300">1-3 iş gününde sistem kurulumu</p>
            </div>

            <div className="text-center p-6 rounded-xl bg-default-950/40 border border-white/10" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="200">
              <div className="inline-flex items-center justify-center h-16 w-16 bg-primary/10 text-primary rounded-xl mb-6 mx-auto">
                <i data-lucide="headphones" className="h-8 w-8"></i>
              </div>
              <h3 className="text-xl font-medium text-white mb-4">7/24 Destek</h3>
              <p className="text-sm text-default-300">Kesintisiz teknik destek hizmeti</p>
            </div>

            <div className="text-center p-6 rounded-xl bg-default-950/40 border border-white/10" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1000" data-aos-delay="300">
              <div className="inline-flex items-center justify-center h-16 w-16 bg-primary/10 text-primary rounded-xl mb-6 mx-auto">
                <i data-lucide="trending-up" className="h-8 w-8"></i>
              </div>
              <h3 className="text-xl font-medium text-white mb-4">Sürekli Gelişim</h3>
              <p className="text-sm text-default-300">Düzenli güncellemeler ve yeni özellikler</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-14">
        <div className="container">
          <div className="bg-default-950/40 backdrop-blur-3xl rounded-xl p-8 text-center" data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1000">
            <div className="inline-flex items-center justify-center h-16 w-16 bg-primary/10 text-primary rounded-xl mb-10 mx-auto">
              <i data-lucide="rocket" className="h-10 w-10"></i>
            </div>
            <h2 className="text-2xl text-white font-medium mb-4">Hemen Başlayın</h2>
            <p className="text-base text-default-200 mb-6 max-w-2xl mx-auto">
              ISP Radius ile işletmenizi büyütmeye başlayın. Uzman ekibimiz size yardımcı olmaktan mutluluk duyacaktır.
            </p>
            <a href="/iletisim" className="inline-flex items-center justify-center gap-2 bg-primary text-white py-2 px-6 rounded-full hover:bg-primary-hover transition-all duration-300">
              İletişime Geçin
              <i data-lucide="arrow-right" className="h-5 w-5"></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Ozellikler;